<template>
  <section class="site-features">
    <div class="site-features__wrapper">
      <h2 class="site-features__wrapper__title site-section-title">
        Fonctionnalités
      </h2>
      <div class="site-features__wrapper__features">
        <div class="site-features__wrapper__features__feature">
          <SiteFeaturesFeature
            icon="cra"
            title="CRA en ligne avec signature"
            text="Remplissez votre calendrier mensuel, signez électroniquement et exportez votre Compte Rendu d'Activité en PDF. Jours fériés détectés automatiquement."
          />
        </div>
        <div class="site-features__wrapper__features__feature">
          <SiteFeaturesFeature
            icon="declaration"
            title="Validation par le client"
            text="Envoyez votre CRA pour validation au client final par email ou lien partageable. Suivi du statut en temps réel. Relances automatiques avec l'offre Intégration."
          />
        </div>
        <div class="site-features__wrapper__features__feature">
          <SiteFeaturesFeature
            icon="invoice"
            title="Connecté à vos outils de facturation"
            text="Avec l'offre Intégration, connectez vos CRA validés à Pennylane, Indy ou Tiime. Votre facture est générée automatiquement dans votre outil comptable."
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  import SiteFeaturesFeature from '@/sections/home/SiteFeatures/SiteFeaturesFeature'
</script>

<style lang="scss">
  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;

  .site-features {
    display: flex;
    justify-content: center;
    background-color: #99B7D033;

    @media screen and (min-width: $tablet-breakpoint) {
      padding-top: 50px;
      padding-bottom: 50px;
    }

    @media screen and (min-width: $desktop-breakpoint) {
      padding-top: 80px;
      padding-bottom: 80px;
    }
    &__wrapper {
      margin: 20px 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1260px;

      &__title {
        color: #01498B;
      }

      &__features {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: stretch;
        
        &__feature {
          max-width: 387px;
          margin: 10px;
          display: flex;
          align-items: stretch;
        }
      }
    }
  }
</style>